import HttpRepository from './httpRepository';

export const DashboardRepository = {
	getCompanyMetrics: async () => {
		const result = await HttpRepository.tradeshiftGo().get('/rest/dashboard/company');
		return result.data;
	},
	getTeamMetrics: async (teamId: string) => {
		const result = await HttpRepository.tradeshiftGo().get(`/rest/dashboard/team/${teamId}`);
		return result.data;
	},
	getManagerMetrics: async (teamId: string) => {
		const result = await HttpRepository.tradeshiftGo().get(`/rest/dashboard/team/${teamId}/manager`);
		return result.data;
	},
	getSettlementsForCompany: async (fromDate: string, toDate: string) => {
		const result = await HttpRepository.tradeshiftGo().get(
			`/rest/payments/settlements/company?from=${fromDate}&to=${toDate}`,
		);
		return result.data;
	},
	getSettlementsForTeam: async (teamId: string, fromDate: string, toDate: string) => {
		const result = await HttpRepository.tradeshiftGo().get(
			`/rest/payments/settlements/team/${teamId}?from=${fromDate}&to=${toDate}`,
		);
		return result.data;
	},
	getSettlementsForTeamManager: async (teamId: string, fromDate: string, toDate: string) => {
		const result = await HttpRepository.tradeshiftGo().get(
			`/rest/payments/settlements/team/${teamId}/manager?from=${fromDate}&to=${toDate}`,
		);
		return result.data;
	},
};
